export const themeTypes = {
    light: 'light',
    dark: 'dark'
};
